import { FC } from 'react';

import { Box } from '../../base/Box';

export const Logo: FC = () => (
  <Box
    xs={{
      padding: '40px 12px',
    }}
    m={{
      padding: 0,
    }}
  >
    <svg
      width="233"
      height="57"
      viewBox="0 0 233 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5249_15085)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.2938 56.0387C46.1362 56.0387 54.5875 47.5873 54.5875 28.7449C54.5875 9.90254 46.1362 1.45117 27.2938 1.45117C8.45136 1.45117 0 9.90254 0 28.7449C0 47.5873 8.45136 56.0387 27.2938 56.0387ZM22.1694 13.0242H29.7624V25.5366H25.0547V17.0521H20.8373L22.1694 13.0242ZM27.2962 44.4646C32.0787 44.4646 35.9556 40.5876 35.9556 35.8052C35.9556 31.0227 32.0787 27.1458 27.2962 27.1458C22.5137 27.1458 18.6367 31.0227 18.6367 35.8052C18.6367 40.5876 22.5137 44.4646 27.2962 44.4646ZM27.2961 40.5334C29.9075 40.5334 32.0243 38.4165 32.0243 35.8052C32.0243 33.1939 29.9075 31.077 27.2961 31.077C24.6849 31.077 22.568 33.1939 22.568 35.8052C22.568 38.4165 24.6849 40.5334 27.2961 40.5334Z"
          fill="white"
        />
      </g>
      <path
        d="M76.1511 41.4545C82.8071 41.4545 87.7031 36.4625 87.7031 29.6145C87.7031 22.7665 82.8071 17.7745 76.1511 17.7745C69.4951 17.7745 64.5991 22.7665 64.5991 29.6145C64.5991 36.4625 69.4951 41.4545 76.1511 41.4545ZM68.8231 29.6145C68.8231 24.8785 71.9271 21.4545 76.1511 21.4545C80.4071 21.4545 83.4791 24.8785 83.4791 29.6145C83.4791 34.2865 80.4071 37.7425 76.1511 37.7425C71.9271 37.7425 68.8231 34.2865 68.8231 29.6145ZM90.8216 40.8145H94.7896V32.2065C94.7896 29.2305 96.0696 27.5345 98.3416 27.5345C100.454 27.5345 101.638 29.0065 101.638 31.5025V40.8145H105.606V30.8945C105.606 26.9265 103.27 24.3345 99.7816 24.3345C97.1896 24.3345 95.3976 25.7745 94.6936 28.1425L94.7896 24.7185H90.8216V40.8145ZM116.534 41.3905C120.438 41.3905 123.382 39.0545 124.022 36.0785L120.63 35.5665C120.086 37.1985 118.486 38.2865 116.566 38.2865C114.134 38.2865 112.374 36.4625 112.246 33.9665H124.31C125.014 28.9425 122.038 24.1425 116.47 24.1425C111.702 24.1425 108.246 27.7585 108.246 32.7505C108.246 37.7745 111.702 41.3905 116.534 41.3905ZM112.278 30.9905C112.566 28.6865 114.262 27.1185 116.47 27.1185C118.838 27.1185 120.47 28.8465 120.47 30.9905H112.278ZM127.358 40.8145H131.422V34.0945L134.974 30.2865L141.95 40.8145H146.686L137.63 27.4705L146.046 18.4145H140.958L131.422 28.8465V18.4145H127.358V40.8145ZM155.503 41.3905C159.407 41.3905 162.351 39.0545 162.991 36.0785L159.599 35.5665C159.055 37.1985 157.455 38.2865 155.535 38.2865C153.103 38.2865 151.343 36.4625 151.215 33.9665H163.279C163.983 28.9425 161.007 24.1425 155.439 24.1425C150.671 24.1425 147.215 27.7585 147.215 32.7505C147.215 37.7745 150.671 41.3905 155.503 41.3905ZM151.247 30.9905C151.535 28.6865 153.231 27.1185 155.439 27.1185C157.807 27.1185 159.439 28.8465 159.439 30.9905H151.247ZM167.792 46.8945H171.888L181.392 24.7185H177.296L172.72 35.8225L168.144 24.7185H163.952L170.64 40.3665L167.792 46.8945Z"
        fill="white"
      />
      <defs>
        <clipPath id="clip0_5249_15085">
          <rect
            width="54.5875"
            height="54.5875"
            fill="white"
            transform="translate(0 1.45117)"
          />
        </clipPath>
      </defs>
    </svg>
  </Box>
);
